import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import AboutMain from "../components/AboutMain";



function About(){
    return(
        <>
        <Header />
        <AboutMain />
        <Footer />
        </>
);
}

export default About; 